import React, { useState } from 'react';
import styles from './styles.module.scss';

interface SlideHeaderProps {
  savingsSubText: string;
  savingsText: string;
  tooltipText: string;
  zipCode?: string;
  totalSavings?: string;
}

/**
 * Header delle slide con benefici, tooltip e totale risparmi
 */
const SlideHeader: React.FC<SlideHeaderProps> = ({
  savingsSubText,
  savingsText,
  tooltipText,
  zipCode,
  totalSavings,
}) => {
  const [showTooltip, setShowTooltip] = useState(false);

  // Aggiungi CAP al sottotitolo se presente
  const displaySubText = zipCode
    ? `${savingsSubText} per il CAP ${zipCode}`
    : savingsSubText;

  return (
    <div className={styles.slideHeader}>
      <div className={styles.savingsSubText}>
        {zipCode ? (
          <>
            {savingsSubText} per il{' '}
            <span className={styles.capLabel}>CAP {zipCode}</span>
          </>
        ) : (
          displaySubText
        )}
      </div>

      <p className={styles.savingsMain}>
        {savingsText}
        <span
          className={styles.infoIcon}
          onMouseEnter={() => setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}
          onClick={() => setShowTooltip(!showTooltip)}
          role="button"
          tabIndex={0}
          aria-label="Dettaglio del vantaggio"
        >
          i
          <span
            className={`${styles.tooltipText} ${showTooltip ? styles.visible : ''}`}
          >
            {tooltipText}
          </span>
        </span>
      </p>

      {totalSavings && (
        <div className={styles.savingsIndicator}>
          <span>Risparmio totale: </span>
          <strong>{totalSavings}</strong>
        </div>
      )}
    </div>
  );
};

export default SlideHeader;
